module.exports = __webpack_public_path__ + "img/en_tis_uninstall6.9711bf88.png";